import React from 'react';
import PropTypes from 'prop-types';
import NavigationContext from './Context';

import {transformNavigation} from './NavigationDataTransforms';

class SampleProvider extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            navigation: null,
        };
    }

    componentDidMount() {
        window.addEventListener('message', this._updateNavMenu);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._updateNavMenu);
    }

    _updateNavMenu = (event) => {
        if (event.data && event.data.type === 'NAV_MENU_UPDATE') {
            this.setState({
                navigation: event.data.body ? transformNavigation(event.data.body) : null,
            });
        }
    };

    render() {
        return (
            <NavigationContext.Provider value={this.state.navigation}>
                {this.props.children}
            </NavigationContext.Provider>
        );
    }
}

SampleProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default SampleProvider;
